'use client';

import { c as _c } from "react/compiler-runtime";
import { useQuery } from '@tanstack/react-query';
import { useSyncExternalStore } from 'react';
import { UnauthQueryOptions } from '@/api';
const TREND_SIZE = 20;
const subscribe = () => () => {};
const getClientSnapshot = () => true;
const getServerSnapshot = () => false;
const trendQueryOptions = UnauthQueryOptions['get:/wello/v2/allows/trend'];
export type TrendKeywordItem = NonNullable<NonNullable<Awaited<ReturnType<NonNullable<ReturnType<typeof trendQueryOptions>['queryFn']>>>['context']>['contents']>[number];
export const useTrendKeywords = () => {
  const $ = _c(7);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = {
      ...trendQueryOptions({
        query: {
          size: TREND_SIZE
        }
      }),
      select: _temp
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const {
    data: t1,
    isPending
  } = useQuery(t0);
  let t2;
  if ($[1] !== t1) {
    t2 = t1 === undefined ? [] : t1;
    $[1] = t1;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  const keywords = t2;
  const isHydrated = useSyncExternalStore(subscribe, getClientSnapshot, getServerSnapshot);
  if (!isHydrated) {
    let t3;
    if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
      t3 = {
        keywords: [],
        isPending: true
      };
      $[3] = t3;
    } else {
      t3 = $[3];
    }
    return t3;
  }
  let t3;
  if ($[4] !== isPending || $[5] !== keywords) {
    t3 = {
      keywords,
      isPending
    };
    $[4] = isPending;
    $[5] = keywords;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  return t3;
};
function _temp(data) {
  return data.context?.contents ?? [];
}